const DATA_TYPE = 'detect';
const MODULE_NAMESPACE = 'detector';
const MODULE_SELECTOR = `[data-${MODULE_NAMESPACE}=module]`;
const INPUT_SELECTOR = `[data-${MODULE_NAMESPACE}=input]`;
const MESSAGES_SELECTOR = `[data-${MODULE_NAMESPACE}=messages]`;

const DEFAULT_EVENT = 'keyup';
const INTERVAL = 500;

class Detector {
  constructor(synonyms, namespace) {
    this.synonyms = synonyms;
    this.namespace = namespace;
    this.eventName = namespace + MODULE_NAMESPACE;

    this.init();
  }

  init() {
    const that = this;

    $(MODULE_SELECTOR).each(function () {
      let $module = $(this);

      that.bindEvents($module);
    });
  }

  detectWord(phrase) {
    let hasWord = false;

    this.synonyms.forEach((synonym) => {
      let reg = new RegExp(/\b/.source + synonym + /s?\b/.source, 'gi');
      let matches = phrase.match(reg);

      if (matches) {
        return hasWord = true;
      }
    });

    return hasWord;
  }

  toggleMessage(phrase, $message) {
    const hasWord = this.detectWord(phrase);

    if (hasWord) {
      $message.show();
    } else {
      $message.hide();
    }
  }

  bindEvents($module) {
    const $input = $module.find(INPUT_SELECTOR);
    const eventType = $input.data('event-type') || DEFAULT_EVENT;
    const eventName = `${eventType}.${this.eventName}`;

    const that = this;
    $input.on(eventName, (event) => {
      if (that._timeout) {
        clearTimeout(that._timeout);
      }

      that._timeout = setTimeout(() => {
        $input.trigger(that.eventName);
      }, INTERVAL);

    }).on(that.eventName, () => {
      const phrase = $input.val();
      const $message = $module.find(`${MESSAGES_SELECTOR} [data-${MODULE_NAMESPACE}=${that.namespace}]`);

      that.toggleMessage(phrase, $message);
    });
  }
}

module.exports = Detector;



// WEBPACK FOOTER //
// ./javascripts/components/detector/base.js